import { render, staticRenderFns } from "./ActivationBriefProposalsRouterView.vue?vue&type=template&id=4c65f3be&scoped=true&"
import script from "./ActivationBriefProposalsRouterView.vue?vue&type=script&lang=js&"
export * from "./ActivationBriefProposalsRouterView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c65f3be",
  null
  
)

export default component.exports